import { combineReducers } from 'redux'
import activeVarsListReducer from '../features/activeVarsList/activeVarsListSlice'
import pendingVarsListReducer from '../features/pendingVarsList/pendingVarsListSlice'
import historyVarsListReducer from '../features/historyVarsList/historyVarsListSlice'
import singleVarReducer from '../features/var/varSlice'
import countriesReducer from '../features/countries/countriesSlice'
import languagesReducer from '../features/languages/languagesSlice'
import translationsReducer from '../features/translations/translationsSlice'
import devicesReducer from '../features/devices/devicesSlice'
import supervisorsReducer from '../features/supervisors/supervisorsSlice'
import varFieldAttachmentsReducer from '../features/varFieldAttachments/varFieldAttachmentsSlice'
import userReducer from '../features/user/user'
import versionReducer from '../features/version/version'

const applicationReducer = combineReducers({
    version: versionReducer,
    user: userReducer,
    supervisors: supervisorsReducer,
    singleVar: singleVarReducer,
    activeVars: activeVarsListReducer,
    pendingVars: pendingVarsListReducer,
    historyVars: historyVarsListReducer,
    countries: countriesReducer,
    languages: languagesReducer,
    translations: translationsReducer,
    devices: devicesReducer,
    varFieldAttachments: varFieldAttachmentsReducer
})

//const listToBeMaintained = ["version", "supervisors", "countries", "issues", "translations", "regions", "languages", "varFieldAttachments"]
const listToBeMaintained = []

const rootReducer = (state, action) => {
    if (action.type === 'auth/logout/fulfilled') {
        let generalState = {}
        for (const i in state) if (listToBeMaintained.some(x => x === i)) generalState[i] = state[i]
        state = generalState
    }
    return applicationReducer(state, action)
}

export default rootReducer;